import React from "react";

function DropDown({ width = 24, height = 25, fill = "#513E3E" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2472_14700)">
        <path d="M7 10L12 15L17 10H7Z" fill={fill} />
      </g>
    </svg>
  );
}

export default DropDown;
